import { observer } from 'mobx-react-lite'
import { Button, EmptyState, Typography } from 'shared/ui'
import { LINK_RCS_GUIDE } from 'shared/constants/links'
import rcsPreviewImg from 'shared/assets/images/rcs/rcs_preview.png'
import { getCDNAssetURL } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { RcsPath } from 'pages/settings/pages/rcs/route/rcsPath'

import styles from './styles.module.scss'

export const RcsStart = observer(() => {
  const handleCreate = () => uiStore.changeRoute({ path: RcsPath.create })

  return (
    <section className={styles.empty}>
      <EmptyState
        title={
          <span className={styles.title}>
            <a
              href={LINK_RCS_GUIDE}
              rel='noreferrer'
              target='_blank'
              className={styles.titlePreview}
            >
              <img alt='RCS preview' src={getCDNAssetURL(rcsPreviewImg)} />
            </a>
            <Typography variant={'heading-lg'} ariaLabel='RCS'>
              RCS
            </Typography>
          </span>
        }
        actions={
          <div className={styles.actions}>
            <Button
              text='New RCS sender'
              size='medium'
              iconProps={{ icon: 'add' }}
              onClick={handleCreate}
              className={styles.createButton}
            />
            <Button
              tag='a'
              href={LINK_RCS_GUIDE}
              target='_blank'
              rel='noreferrer'
              text='Help guide'
              size='medium'
              contained='secondary'
              iconProps={{ icon: 'info' }}
              className={styles.guideButton}
            />
          </div>
        }
        text={
          <>
            Next-gen messaging with rich media, branded sender ID, and interactive
            <br />
            features
          </>
        }
        typographyProps={{
          variant: 'body-lg-regular',
          ariaLabel: 'KnowledgeBaseText',
          marginTop: '4px',
        }}
        boxProps={{
          gap: '20px',
          width: 'unset',
          height: 'unset',
          textAlign: 'center',
        }}
        noIcon
      />
    </section>
  )
})
